<div class="d-flex flex-column">
  @if (label) {
    <div class="label" [ngClass]="{ 'text-danger': error }">
      {{ label }}
      @if (required) {
        <span>*</span>
      }
    </div>
  }
  <input
    #inputRef
    class="custom-input"
    autocomplete="off"
    [class]="customClass"
    mask="+000-00-000-00-00"
    [disabled]="disabled"
    [(ngModel)]="inputValue"
    [placeholder]="placeholder"
    (ngModelChange)="onInputChange($event, true)"
    [ngClass]="{ 'disabled-input': disabled, 'danger-border': error }"
  />
</div>
